import React from "react";
import get from "lodash/get";
import { useQuery, useMutation } from "services/Client";
import { useNavigate, useParams } from "react-router-dom";
import { useNotification } from "hooks";

import List from "./View";

function AllLessons() {
  const { unitId } = useParams();
  const notification = useNotification
  const { data } = useQuery({
    event: "lesson.get.many",
    variables: {
      where: { unitId: { _eq: unitId } },
    },
  });

  const dataList = get(data, "lesson", [])
    .slice(0)
    .sort((a, b) => a.order - b.order);

  const { mutate: deleteTest } = useMutation({
    event: "lesson.delete",
  });
  let navigate = useNavigate();

  const removeTest = async (mutate, id) => {
    mutate({ variables: { where: { id } } })
      .then((res) => {
        if (get(res, "data.deletelevel.id")) {
          notification.success("Delete Successful");
        } else {
          notification.error("Error");
        }
      })
      .catch((e) => {});
  };
  return (
    <List
      data={dataList}
      handleCreate={() => navigate("new")}
      handleDelete={(id) => removeTest(deleteTest, id)}
    />
  );
}

export default AllLessons
